export default function setSourceAction(source) {
    return {
        type: 'SET_SOURCE',
        payload: source
    }
}